var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#00FFC2",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-108",
    fill: "#FF0064",
    points: "1.13686838e-14 14.2354 7.7646 22 0.0001 29.7646"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-110",
    fill: "#FF0064",
    points: "32 29.76338 24.2354 21.99878 31.9998 14.23438"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-112",
    fill: "#FF0064",
    points: "23.76411 0 15.99941 7.7646 8.23481 0.0001"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-114",
    fill: "#FF0064",
    points: "8.23608 44 16.00068 36.2354 23.76518 43.9999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-116",
    fill: "#181C4B",
    points: "21.53606 28.34046 15.99996 22.80436 10.46386 28.34046 15.99996 33.87656"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-118",
    fill: "#181C4B",
    points: "21.53606 15.65955 15.99996 10.12355 10.46386 15.65955 15.99996 21.19565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-120",
    fill: "#181C4B",
    points: "9.65977 27.53645 15.19557 22.00005 9.65937 16.46355 4.12347 21.99995"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-122",
    fill: "#181C4B",
    points: "22.34067 27.53648 27.87647 22.00008 22.34027 16.46358 16.80437 21.99998"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.4d359cb9febb395bdbd09fe2a88a1de2.svg";
export { ForwardRef as ReactComponent };